import { IoMdPerson } from "react-icons/io";
import { GiPadlock } from "react-icons/gi";
import { IoEyeSharp } from "react-icons/io5";
import { FaEyeSlash } from "react-icons/fa6";
import { useState } from "react";
import { auth } from "../firebaseconfig/firebase";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";

const LoginPage = ({ setIsAuth }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState("");
  const [resetError, setResetError] = useState("");
  const [signinEmail, setSignInEmail] = useState("");
  const [signinPassword, setSignInPassword] = useState("");
  const [login, setLogin] = useState(false);
  const navigate = useNavigate();

  
  const handleForgotPassword = async () => {
  if (!signinEmail) {
    setResetError("Please enter your email first.");
    return;
  }

  setResetLoading(true);
  setResetError("");
  setResetMessage("");

  try {
    await sendPasswordResetEmail(auth, signinEmail);
    setResetMessage("Password reset email sent. Check your inbox.");
  } catch (err) {
    if (err.code === "auth/user-not-found") {
      setResetError("No account found with this email.");
    } else if (err.code === "auth/invalid-email") {
      setResetError("Invalid email address.");
    } else {
      setResetError("Something went wrong. Try again.");
    }
  } finally {
    setResetLoading(false);
  }
};


  const signinwithemailandpassword = async (event) => {
    event.preventDefault();
    setLogin(true);
    setError("");
    setEmailError(false);
    setPasswordError(false);
    if (!signinEmail || !signinPassword) {
      setError("Email and password are required");
      return;
    }
    try {
      await signInWithEmailAndPassword(auth, signinEmail, signinPassword);
      localStorage.setItem("isAuth", true);
      setIsAuth(true);
      navigate("/home");
      alert("successful");
      // setLogin(true);
    } catch (error) {
      console.log(error);
      if (
        error.code === "auth/user-not-found" ||
        error.code === "auth/invalid-email"
      ) {
        setEmailError(true);
        setError("Invalid email address");
      }

      if (
        error.code === "auth/wrong-password" ||
        error.code === "auth/invalid-credential"
      ) {
        setPasswordError(true);
        setError("Incorrect password");
      }

      if (error.code === "auth/too-many-requests") {
        setError("Too many attempts. Try again later.");
      }
    } finally {
      setLogin(false);
    }
  };

  return (
    // <div className="bg-blue-950 h-[100vh] w-[100%] flex justify-center items-center">
    //   <div className="flex flex-col gap-2 text-white">
    //     <h1 className="font-bold text-6xl">Welcome Back</h1>
    //     <p className="text-base">Login to access your account</p>
    //     <form className="flex flex-col gap-3">
    //       <label>Email</label>
    //       <div className="relative">
    //         <IoMdPerson className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 size-8" />
    //         <input
    //           onChange={(e) => setSignInEmail(e.target.value)}
    //           type="email"
    //           className={`size-4 border-2 border-gray-300 h-14 bg-transparent rounded-md w-full pl-14 ${
    //             emailError ? "border-red-500" : "border-gray-300"
    //           }`}
    //           placeholder="you@example.com"
    //         />
    //       </div>

    //       <label>Password</label>
    //       <div className="relative">
    //         <GiPadlock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 size-8" />
    //         <input
    //           onChange={(e) => setSignInPassword(e.target.value)}
    //           type={showPassword ? "text" : "password"}
    //           className={`border-2 border-gray-300 h-14 bg-transparent rounded-md w-full pl-14 ${
    //             passwordError ? "border-red-500" : "border-gray-300"
    //           } `}
    //           placeholder="Enter your Password"
    //         />
    //         <span
    //           onClick={() => setShowPassword(!showPassword)}
    //           className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
    //         >
    //           {showPassword ? (
    //             <FaEyeSlash size={22} />
    //           ) : (
    //             <IoEyeSharp size={22} />
    //           )}
    //         </span>
    //       </div>
    //     </form>
    //     {/* <p className="underline cursor-pointer">Forgot Password?</p> */}
    //     <button
    //       type="button"
    //       onClick={handleForgotPassword}
    //       disabled={resetLoading}
    //       className="text-left underline text-sm text-blue-400 hover:text-blue-300 disabled:opacity-50"
    //     >
    //       {resetLoading ? "Sending reset email..." : "Forgot Password?"}
    //     </button>

    //     {resetError && (
    //       <p className="text-red-400 text-sm mt-1">{resetError}</p>
    //     )}

    //     {resetMessage && (
    //       <p className="text-green-400 text-sm mt-1">{resetMessage}</p>
    //     )}

    //     <div
    //       onClick={signinwithemailandpassword}
    //       className="bg-blue-900 flex justify-center cursor-pointer items-center text-center h-12"
    //     >
    //       <button
    //         onClick={signinwithemailandpassword}
    //         className="font-bold text-white-700"
    //       >
    //         {" "}
    //         {login ? "Logging In..." : "Log In"}{" "}
    //       </button>
    //     </div>
    //     <p className="text-center">
    //       Don't have an account?{" "}
    //       <span className="text-blue-700">
    //         <Link to="/register">Sign Up</Link>
    //       </span>
    //     </p>
    //   </div>
    //   {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    // </div>
    <div className="bg-blue-950 min-h-screen w-full flex justify-center items-center px-4">
  <div className="w-full max-w-md flex flex-col gap-4 text-white">

    {/* Header */}
    <h1 className="font-bold text-3xl sm:text-4xl md:text-6xl text-center sm:text-left">
      Welcome Back
    </h1>
    <p className="text-sm sm:text-base text-center sm:text-left">
      Login to access your account
    </p>

    {/* Form */}
    <form className="flex flex-col gap-3">
      <label className="text-sm">Email</label>
      <div className="relative">
        <IoMdPerson className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-6 h-6" />
        <input
          onChange={(e) => setSignInEmail(e.target.value)}
          type="email"
          className={`border-2 h-12 sm:h-14 bg-transparent rounded-md w-full pl-12 sm:pl-14 text-sm sm:text-base
            ${emailError ? "border-red-500" : "border-gray-300"}
          `}
          placeholder="you@example.com"
        />
      </div>

      <label className="text-sm">Password</label>
      <div className="relative">
        <GiPadlock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-6 h-6" />
        <input
          onChange={(e) => setSignInPassword(e.target.value)}
          type={showPassword ? "text" : "password"}
          className={`border-2 h-12 sm:h-14 bg-transparent rounded-md w-full pl-12 sm:pl-14 text-sm sm:text-base
            ${passwordError ? "border-red-500" : "border-gray-300"}
          `}
          placeholder="Enter your Password"
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
        >
          {showPassword ? <FaEyeSlash size={20} /> : <IoEyeSharp size={20} />}
        </span>
      </div>
    </form>

    {/* Forgot Password */}
    <button
      type="button"
      onClick={handleForgotPassword}
      disabled={resetLoading}
      className="text-left underline text-sm text-blue-400 hover:text-blue-300 disabled:opacity-50"
    >
      {resetLoading ? "Sending reset email..." : "Forgot Password?"}
    </button>

    {resetError && (
      <p className="text-red-400 text-sm">{resetError}</p>
    )}

    {resetMessage && (
      <p className="text-green-400 text-sm">{resetMessage}</p>
    )}

    {/* Login Button */}
    <button
      onClick={signinwithemailandpassword}
      className="bg-blue-900 hover:bg-blue-800 transition w-full h-12 rounded-md font-bold text-sm sm:text-base"
    >
      {login ? "Logging In..." : "Log In"}
    </button>

    {/* Sign up */}
    <p className="text-center text-sm">
      Don&apos;t have an account?{" "}
      <Link to="/register" className="text-blue-400 hover:underline">
        Sign Up
      </Link>
    </p>

    {/* General Error */}
    {error && (
      <p className="text-red-500 text-sm text-center">{error}</p>
    )}
  </div>
</div>

  );
};
export default LoginPage;
